import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { PlaceNode } from '@ulysses-inc/harami_api_client'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import PlaceGroupsTree from 'src/features/schedules/editSchedule/PlaceGroupsTree'
import {
  editorPermissions,
  hasPermission,
} from 'src/libraries/roles/permissions'
import { RootState } from 'src/state/store'
import { TBaseFormRowProps } from './EditSchedule'

type CheckedKeys =
  | (string | number)[]
  | {
      checked: (string | number)[]
      halfChecked: (string | number)[]
    }

const SchedulePlaceRow: React.FC<
  TBaseFormRowProps<{
    placeNodes: PlaceNode[]
  }>
> = ({
  setFieldValue,
  placeNodes: existingPlaceNodes,
  values: { placeNodes },
  errors,
  touched,
}) => {
  const [visibleNoPlaceModal, setVisibleNoPlaceModal] = useState<boolean>(true)
  const isLoadingPlaceNodes = useSelector(
    (state: RootState) => state.placesState.placeGroups.isLoading,
  )
  const isActive = useSelector(
    (state: RootState) => state.schedulesState.schedule.schedule.isActive,
  )

  const onCheck = (checkedKeys: CheckedKeys) => {
    if (isActive) {
      setFieldValue('startReportDate', undefined)
      setFieldValue('endReportDate', undefined)
    }
    setFieldValue('placeNodes', checkedKeys)
  }
  const onCancel = () => setVisibleNoPlaceModal(false)

  const hasPlaceNodes =
    existingPlaceNodes !== undefined && existingPlaceNodes.length > 0
  const hadNoPlaceNodes = !isLoadingPlaceNodes && !hasPlaceNodes
  const isEditor = hasPermission(editorPermissions)

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1" fontWeight="bold">
        現場
      </Typography>
      {hasPlaceNodes && (
        <PlaceGroupsTree
          placeNodes={existingPlaceNodes}
          onCheck={onCheck}
          checkedKeys={placeNodes ?? []}
        />
      )}
      {hadNoPlaceNodes && (
        <Dialog open={visibleNoPlaceModal} onClose={onCancel}>
          <DialogTitle>
            現場グループが未登録のため、スケジュールが作成できません。
          </DialogTitle>
          <DialogContent>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <Stack spacing={1}>
                {isEditor && (
                  <Typography>
                    <Link to="/places">現場設定</Link>と
                    <Link to="/placeGroups">現場グループ設定</Link>
                    で追加してください。
                  </Typography>
                )}
                {!isEditor && (
                  <Typography>
                    現場・現場グループ設定から登録してください。
                  </Typography>
                )}
              </Stack>
            </Stack>
          </DialogContent>
          {isEditor ? (
            <DialogActions>
              <Link to="/placeGroups">
                <Button onClick={onCancel} variant="outlined" color="primary">
                  現場グループ設定へ移動
                </Button>
              </Link>
              <Link to="/places">
                <Button onClick={onCancel} variant="contained" color="primary">
                  現場設定へ移動
                </Button>
              </Link>
            </DialogActions>
          ) : (
            <DialogActions>
              <Button onClick={onCancel} variant="contained" color="primary">
                閉じる
              </Button>
            </DialogActions>
          )}
        </Dialog>
      )}
      <Stack>
        <FormikErrorMessage
          name="placeNodes"
          errors={errors}
          touched={touched}
        />
      </Stack>
    </Stack>
  )
}

export default SchedulePlaceRow
